<section class="login">
  <div class="container">
    <div class="row justify-content-center">
      <section class="col-12" [ngClass]="fullSize? '': 'col-xl-6 container container-wrapper'">
        <div class="row">
          <section class="col-md-12">
            <app-partner-registration [partner]="partner" [showPassword]="showPassword" [password]="password"
              [showEmailAgree]="false" [showAGBAgree]="showTermsConditionsLink" [showInternalReference]="showInternalReference" (eventRegistrationDataValid)="onRegistrationDataValid()"
              [showLoginUrl]="showLoginUrl" (eventLogin)="onLogin()" (eventRegistrationDataInvalid)="onRegistrationDataInvalid()"
              [title]="'Your Personal Data' | translate"
              [description]="'Please enter your contact information, which you can change at any time in your profile.' | translate"
              [fieldsConfigurations]="fieldsConfigurations">
            </app-partner-registration>
          </section>
          <!-- <section class="col-md-1 d-none d-md-block">
            <div class="row separator-v">
              <div></div>
            </div>
          </section>
          <section class="col-md-3 d-none d-md-block">
            <h3>{{ 'Your advantages' | translate }}</h3>
            <ul>
              <li>{{ 'Manage personal data' | translate }}</li>
              <li>{{ 'Giftcards & Order Overview' | translate }}</li>
              <li>{{ 'Manage relatives' | translate }}</li>
              <li>{{ 'Fast Check-In on site' | translate }}</li>
            </ul>
          </section> -->
        </div>

        <div class="row">
          <div class="col-12">
            <app-backward-forward [hideBack]="!showBack" (backwardClick)="onBack()" [nextTitle]="'Sign Up' | translate"
              (forwardClick)="onRegister()" [forwardEnabled]="isRegistrationEnabled">
            </app-backward-forward>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
